var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36918",
    "data-name": "Group 36918",
    transform: "translate(7734 -11784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Edit",
    "data-name": "Iconly/Light-Outline/Edit",
    transform: "translate(-7733.202 11785.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M25.389,23.614a1.016,1.016,0,1,1,0,2.031H15.568a1.016,1.016,0,1,1,0-2.031ZM19.114.885,21.447,2.7a3.82,3.82,0,0,1,1.71,2.4,3.876,3.876,0,0,1-.5,2.98c0,.006-.008.012-.021.029l-.01.014c-.092.121-.49.625-2.5,3.144a.813.813,0,0,1-.063.094,1.02,1.02,0,0,1-.11.122l-.434.545-.309.387-2.288,2.865-.46.576L9.679,24.345a3.313,3.313,0,0,1-2.554,1.238L2.2,25.645H2.184a1.016,1.016,0,0,1-.988-.781l-1.109-4.7A3.211,3.211,0,0,1,.71,17.405L13.465,1.452l.015-.018A4.068,4.068,0,0,1,19.114.885Zm-7.071,5.6L2.3,18.674A1.19,1.19,0,0,0,2.064,19.7L2.986,23.6,7.1,23.551a1.284,1.284,0,0,0,.993-.477l4.38-5.481.564-.706h0l.565-.707,4.21-5.269Zm3-3.751L13.311,4.895l5.769,4.429c1.11-1.391,1.841-2.307,1.909-2.394a1.841,1.841,0,0,0,.192-1.359,1.911,1.911,0,0,0-.883-1.2c-.1-.066-2.378-1.837-2.448-1.893A2.027,2.027,0,0,0,15.044,2.731Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1169",
    "data-name": "Rectangle 1169",
    width: 28,
    height: 28,
    transform: "translate(-7734 11784)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditer);
export default __webpack_public_path__ + "static/media/editer.adddd54e56bbae5fd63044ee131ea4d3.svg";
export { ForwardRef as ReactComponent };